import "./css/InfoEvent.css";

export default function InfoEvent({event}) {
  	return (
        <>
            <div className="card card-action mb-4">
                <div className="card-header align-items-center flex-wrap gap-2">
                    <h5 className="card-action-title mb-0">Informazioni</h5>
                    <div className="card-action-element">
                        <button className="btn btn-primary btn-sm edit-address" type="button">
                            <i className="bx bx-plus bx-xs me-1_5"></i>Modifica
                        </button>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-xl-7 col-12">
                            <dl className="row mb-0 gx-2">
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">Email:</dt>
                                <dd className="col-sm-8">{event.email ? event.email : 'Non inserita'}</dd>
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">Telefono:</dt>
                                <dd className="col-sm-8">{event.phone ? event.phone : 'Non inserito'}</dd>
                            </dl>
                        </div>
                        <div className="col-xl-5 col-12">
                            <dl className="row mb-0 gx-2">
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">Note:</dt>
                                <dd className="col-sm-8">{event.note ? event.note : 'Non inserita'}</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card card-action mb-6">
                <div className="card-header align-items-center">
                    <h5 className="card-action-title mb-0">Vettore</h5>
                    {!event.vector && (
                    <div className="card-action-element">
                        <button className="btn btn-primary btn-sm edit-address" type="button">
                            <i className="bx bx-plus bx-xs me-1_5"></i>Aggiungi
                        </button>
                    </div>
                    )}
                </div>
                <div className="card-body">
                    <div className="added-cards">
                    {event.vector && (
                        <div className="cardMaster border p-6 rounded mb-4">
                            <div className="d-flex justify-content-between flex-sm-row flex-column">
                                <div className="card-information">
                                    <span className={`badge me-1 ${event.vector.status ? "bg-label-success" : "bg-label-danger"}`}>
                                        {event.vector.status ? 'Attivo': 'Non Attivo'}
                                    </span>
                                    <div className="d-flex align-items-center mb-2">
                                        <h6 className="mb-0 me-2">{event.vector.name}</h6>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <p className="mb-0 me-2">Indirizzo: {event.vector.address ? event.vector.address : ''} {event.vector.comune ? event.vector.comune : ''} {event.vector.provincia ? '- ('+ event.vector.provincia +')' : ''} {event.vector.cap ? event.vector.cap : ''}</p>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <p className="mb-0 me-2">Nazione: {event.vector.nazione ? event.vector.nazione : 'Non inserita'} </p>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <p className="mb-0 me-2">Referente: {event.vector.referent ? event.vector.referent : 'Non inserito'} </p>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <p className="mb-0 me-2">Telefono: {event.vector.phone ? event.vector.phone : 'Non inserito'} </p>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <p className="mb-0 me-2">Note: {event.vector.note ? event.vector.note : 'Non inserite'} </p>
                                    </div>
                                </div>
                                <div className="d-flex flex-column text-start text-lg-end">
                                    <div className="d-flex order-sm-0 order-1">
                                        <button className="btn btn-sm btn-label-primary me-4">Modifica</button>
                                        <button className="btn btn-sm btn-label-danger">Cancella</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {!event.vector && (
                        <h6 className="card-action-title mb-0">Non inserito</h6>
                    )}
                    </div>
                </div>
            </div>
        </>
	);
}